module.exports = __webpack_public_path__ + "static/img/tallpopie.e5556b24.png";